// extracted by mini-css-extract-plugin
export default {"switch":"Q3rcL","image":"lo7ID","slider":"z0so8","dark":"NfrJn"};